import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';
import { I18n } from 'aws-amplify';

import Config from '../../config';

import { BP_PROJECT_UPDATE } from './actions';

import { 
    notification,
} from 'antd';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

export const add_products_exception = (data) => {
    return (dispatch, getState) => {

        return Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.post(`${Config.API_BASE_URL}/bp/admin/client-exception-add-product`, data, config)
                .then(response => {

                    const payload = {
                        exceptions: response.data,
                        errors: {},
                        errorsAddProduct: {},
                        task: {
                            result: true
                        }
                    };

                    dispatch({
                        type: BP_PROJECT_UPDATE,
                        payload: payload
                    })

                    notification.success({
                        message: I18n.get('Atualizado com sucesso!'),
                    });

                    return payload;
                })
                .catch(error => {

                    // Nao faz o dispatch no erro, tratamento direto na tela
                    const payload = {
                        errorsAddProduct: error.response.data,
                        task: {
                            result: false
                        }
                    };

                    dispatch({
                        type: BP_PROJECT_UPDATE,
                        payload: payload
                    })

                    notification.error({
                        message: I18n.get('Algo deu errado!'),
                        description: I18n.get('Tente novamente mais tarde'),
                    });

                    return payload;

                });
        }).catch(error => {
            // dispatch({ type: EXPIRED });
        });
    };
}

export default add_products_exception;